import { html, ref, when } from '@microsoft/fast-element';
import { eventDetail } from '../../utils/formatting';
import type { SellerRfq } from './seller-rfq';
import { sync } from '@genesislcap/foundation-utils';
import { whiteCheckIconTwo, whiteErrorIconTwo } from '../../styles';
import { PROFILE_RIGHTS } from '../../utils';

export enum SELLER_RFQ_TABS {
  MY_PROJECTS_TAB = 'myProjects',
  RFQ_LISTING_TAB = 'rfqListing',
  MY_PROJECTS_PANEL = 'myProjectsPanel',
  RFQ_LISTING_PANEL = 'rfqListingPanel',
}

export const SellerRfqTemplate = html<SellerRfq>`
  <div class="cascade-route-content">
    <div class="seller-rfq">
      <div class="side-card">
        <zero-card class="no-padding-card">
          <seller-rfq-query
            @updateCriteria="${(x, c) => (x.criteria = eventDetail(c))}"
            :projectSelected=${(x) => x.projectSelected}
          ></seller-rfq-query>
        </zero-card>
      </div>
      <div class="grid-card">
        <zero-card class="no-padding-card">
          <zero-tabs ${ref('fullTabRef')} class="basket-tabs" id="full-tab" activeid="rfq-basket">
            <zero-tab id="rfq-basket">RFQ Basket</zero-tab>
            <zero-tab id="graphical-view" @click=${(x) => x.projectRfqsGraphRef.reflow()}>
              Graphical View
            </zero-tab>
            <zero-tab-panel id="rfq-basket-Panel">
              <basket-listing
                @proposeVppa="${(x, c) => x.proposeVppa(eventDetail(c))}"
                ${ref('basketListingElement')}
              ></basket-listing>
            </zero-tab-panel>
            <zero-tab-panel id="graphical-view-Panel">
              <project-rfqs-graph
                :projectSelected=${(x) => x.projectSelected}
                ${ref('projectRfqsGraphRef')}
              ></project-rfqs-graph>
            </zero-tab-panel>
            <span slot="end">
              <zero-button
                @click="${(x) => x.downloadBasketCsv()}"
                class="download-btn"
                appearance="tab-primary"
                style="display: ${(x) => (x.fullTabRef.activeid === 'rfq-basket' ? '' : 'none')}"
              >
                Download
              </zero-button>
            </span>
          </zero-tabs>
        </zero-card>
        <zero-card class="no-padding-card" style="display: ${(x) => (x.selectedRfq ? 'none' : '')}">
          <zero-tabs ${ref('sellerRfqTabs')} activeId=${SELLER_RFQ_TABS.MY_PROJECTS_TAB}>
            <zero-tab
              slot="tab"
              id=${SELLER_RFQ_TABS.RFQ_LISTING_TAB}
              @click=${(x) => x.rfqListing()}
            >
              RFQ Listing
            </zero-tab>
            <zero-tab
              slot="tab"
              id=${SELLER_RFQ_TABS.MY_PROJECTS_TAB}
              @click=${(x) => x.myProjects()}
            >
              My Projects
            </zero-tab>
            <zero-tab-panel
              slot="tabpanel"
              id=${SELLER_RFQ_TABS.RFQ_LISTING_PANEL}
              @click=${(x) => x.rfqListing()}
            ></zero-tab-panel>
            <zero-tab-panel
              slot="tabpanel"
              id=${SELLER_RFQ_TABS.MY_PROJECTS_PANEL}
              @click=${(x) => x.myProjects()}
            ></zero-tab-panel>
          </zero-tabs>
          <rfq-listing
            @rfqSelected="${(x, c) => x.rfqSelected(eventDetail(c))}"
            style="display: ${(x) => (x.isMyProjectsTabSelected ? 'none' : '')}"
            ${ref('rfqListingElement')}
          ></rfq-listing>
          <project-listing
            @projectSelected="${(x, c) => x.projectSelection(eventDetail(c))}"
            style="display: ${(x) => (x.isMyProjectsTabSelected ? '' : 'none')}"
            :activeTabId=${(x) => x.sellerRfqTabs.activeid}
          ></project-listing>
        </zero-card>
        <zero-card class="no-padding-card" style="display: ${(x) => (x.selectedRfq ? '' : 'none')}">
          <zero-tabs>
            <span slot="start" class="tab-title">Propose Contract</span>
            <tab-buttons slot="start">
              <zero-button
                slot="buttons"
                class="seller-rfq-button-style-left"
                @click=${(x) => x.openVppaModal()}
              >
                ${whiteCheckIconTwo('start')} New Contract
              </zero-button>
            </tab-buttons>
            <tab-buttons slot="end">
              <zero-button
                slot="buttons"
                appearance="chat-reject"
                class="seller-rfq-button-style"
                @click=${(x) => x.cancelVppaSelection()}
              >
                ${whiteErrorIconTwo('start')} Cancel
              </zero-button>
              ${when(
                (x) => x.authService.validateProfile(PROFILE_RIGHTS.UPSERT_NEGOTIATION),
                html`
                  <zero-button
                    slot="buttons"
                    appearance="primary"
                    class="seller-rfq-button-style"
                    ?disabled="${(x) => !x.selectedVppa}"
                    @click=${(x) => x.openStructuredChat()}
                  >
                    ${whiteCheckIconTwo('start')} Create Proposal
                  </zero-button>
                `,
              )}
            </tab-buttons>
          </zero-tabs>
          <vppa-listing
            :selectedRfq=${sync((x) => x.selectedRfq)}
            :projectSelected=${(x) => x.projectSelected}
            @selectedVppa=${(x, c) => x.vppaSelected(eventDetail(c))}
            @proposalCreated=${(x) => x.proposalCreated()}
          ></vppa-listing>
        </zero-card>
      </div>
    </div>
  </div>
  <vppa-modal ${ref('vppaModal')}></vppa-modal>
`;
